import { domain } from './utils';

// Set/Update session TTL
export const setSession = domain.event<void>();
// Set session TTL to 0
export const endSession = domain.event<void>();
// Service reset
export const reset = domain.event<void>();
